import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import NewsCard from '../components/NewsCard';
import Typography from '@mui/material/Typography';
// import img from '../img/image.png';
import Container from '@mui/material/Container';
import { useState, useEffect } from 'react';
import { fetchNews } from '../strapi';

function News({ content, setNewsId, locale }) {
    const [news, setNews] = useState([]);
    useEffect(() => {
        fetchNews(locale)
            .then(data => {
                setNews(data);
            })
            .catch(err => {
            });
    }, [locale]);
    // let title = 'Новости'

    return (
        <div >
            <Container>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {content?.title || ''}
                </Typography>
                <Typography className='mainText' component="div">
                    {content?.text || ''}
                </Typography>
                <AliceCarousel
                    controlsStrategy="responsive"
                    responsive={{
                        0: {
                            items: 1,
                        },
                        780: {
                            items: 2,
                            itemsFit: 'contain',
                        },
                        1280: {
                            items: 3,
                            itemsFit: 'contain',
                        },
                    }}
                    renderPrevButton={({ isDisabled }) => (
                        <span
                            style={{
                                position: 'absolute',
                                left: -40,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#2D5B96',
                                border: 'none',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                zIndex: 2,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.5 : 1,
                                fontSize: 40,
                                fontWeight: 'bold',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            disabled={isDisabled}
                            aria-label="previous"
                        >&#8592;</span>
                    )}
                    renderNextButton={({ isDisabled }) => (
                        <span
                            style={{
                                position: 'absolute',
                                right: -40,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#2D5B96',
                                border: 'none',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                zIndex: 2,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.5 : 1,
                                fontSize: 40,
                                fontWeight: 'bold',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center', 
                            }}
                            disabled={isDisabled}
                            aria-label="next"
                        >&#8594;</span>
                    )}
                    style={{ position: 'relative', padding: '0 80px' }}
                >
                    {news != null && news.map((item, index) =>
                        <NewsCard key={item.documentId || index}
                            id={item.documentId}
                            setNewsId={setNewsId}
                            title={item.title}
                            text={item.subtitle}
                            date={item.date}
                            img={item.mainImg !== null ? item.mainImg.url : ''}
                            locale={locale} />
                    )}
                </AliceCarousel>
            </Container>

        </div>
    );
}

export default News;
